import { briefingApi } from '@/apis';
import { useQuery } from '@tanstack/react-query';

export function useIntelligenceItem(code, defaultValue) {
  return useQuery({
    queryKey: ['intelligence', code],
    queryFn: () => {
      if (code === 'new') {
        return defaultValue;
      }

      return briefingApi.get(`intelligence/${code}`).json();
    },
    enabled: !!code,
  });
}
